import { gql, useMutation } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { CreateSepaSetupIntentInput, CreateSepaSetupIntentPayload } from "@oysterhr/schema"

const PAYMENT_METHODS_COMPANY_CREATE_SEPA_SETUP_INTENT = gql`
  mutation PAYMENT_METHODS_COMPANY_CREATE_SEPA_SETUP_INTENT($companyId: ID!) {
    createSepaSetupIntent(input: { companyId: $companyId }) {
      errors
      setupIntent {
        clientSecret
      }
    }
  }
`
const useCreateSepaSetupIntent = (
  options?: InjectedOptions<
    { createSepaSetupIntent: CreateSepaSetupIntentPayload },
    CreateSepaSetupIntentInput
  >,
) => useMutation(PAYMENT_METHODS_COMPANY_CREATE_SEPA_SETUP_INTENT, options)

export default useCreateSepaSetupIntent
